import Socials from "./Socials";
import Block from "./Block";
import { Link } from "react-router-dom";
import ITSFINAL_MAIN_LOGO from "../../assets/ITSFINAL_MAIN_LOGO.png"

export default function Footer() {
    return (
        <div className="w-full bg-dark-one flex flex-col lg:items-center gap-12 p-6 lg:border-t-[1px] border-dark-border">
            <div className="flex flex-col gap-8 mt-1 lg:hidden">
                <Socials/>
                <div className="flex flex-col gap-8">
                    <div>
                        <p className="text-epic-blue text-xs">quick links</p>
                        <nav>
                            <ul className="flex flex-col gap-2 mt-2 text-white-main text-sm">
                                <li><Link to={"/"}>homepage</Link></li>
                                <li><Link to={"/play"}>play</Link></li>
                                <li><Link to={"/builder"}>emblem builder</Link></li>
                                <li><Link to={"/guardian"}>guardian</Link></li>
                                <li><Link to={"/privacy"}>privacy</Link></li>
                               
                                <li><Link to={"/donations"}>donate</Link></li>
                                <li><Link to={"/faq"}>faq</Link></li>
                            </ul>
                        </nav>
                    </div>
                    <div>
                        <p className="text-epic-blue text-xs">related</p>
                        <nav>
                            <ul className="flex flex-col gap-2 mt-2 text-white-main text-sm">
                                <li><Link to={"https://discord.gg/EXDay6NQbH"}>discord server</Link></li>
                                <li><Link to={"https://symboltracker.net/"}>symboltracker</Link></li>
                                {/* <li><Link to={"/game2give"}>game 2 give 25</Link></li> */}
                                <li><Link to={"https://www.bungie.net/en/ClanV2?groupid=5288592"}>itsfinal clan</Link></li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <img className="w-[240px] mx-auto" src={ITSFINAL_MAIN_LOGO} alt=""/>
                <p className="text-dark-back text-xs text-center mb-2">&copy;2025 ITSFINAL - An Astral Labs Project</p>
            </div>
            <div className="lg:w-4/5 2xl:w-8/12 hidden lg:flex flex-col justify-center items-center gap-16 py-20">
                <div className="w-full flex gap-8 items-center">
                    <Block 
                        blockTopText={"choose your champion"} 
                        blockBottomText={"play"} 
                        blockPath={"/play"}    
                    />
                    <Block 
                        blockTopText={"craft an epic emblem"} 
                        blockBottomText={"builder"} 
                        blockPath={"/builder"} 
                    />
                    <Block 
                        blockTopText={"drive the project forward"} 
                        blockBottomText={"donate"} 
                        blockPath={"/donations"} 
                    />
                </div>
                <div className="w-full flex justify-between items-center relative">
                    <img className="w-80" src={ITSFINAL_MAIN_LOGO} alt=""/>
                    <p className="text-dark-back text-center text-lg absolute left-1/2 -translate-x-1/2">&copy;2025 ITSFINAL - An Astral Labs Project</p>
                    <Socials/>
                </div>
                <div className="w-full flex justify-end items-center">
                    <nav>
                        <ul className="flex gap-4 mt-2 text-white-main text-xs">
                            <li><Link to={"https://discord.gg/EXDay6NQbH"}>discord server</Link></li>
                            <li><Link to={"/privacy"}>privacy</Link></li>
                            <li><Link to={"/faq"}>faq</Link></li>
                            <li><Link to={"https://symboltracker.net/"}>symboltracker</Link></li>
                            <li><Link to={"https://www.bungie.net/en/ClanV2?groupid=5288592"}>itsfinal clan</Link></li>
                            {/* <li><Link to={"/game2give"}>game 2 give 25</Link></li> */}
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    )
}